/* Jamun cart-drawer upsell — AJAX add-to-cart that refreshes the drawer in place. */
(function () {
  if (customElements.get('jamun-cart-upsell')) return;

  customElements.define('jamun-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-jcu-form]');
      this.btn = this.querySelector('[data-jcu-atc]');
      this.variant = this.querySelector('[data-jcu-variant]');
      this.errorEl = this.querySelector('[data-jcu-error]');
      this.addUrl = this.dataset.cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add';
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    get onCartPage() {
      return document.body.classList.contains('template-cart') || /\/cart($|\/|\?)/.test(window.location.pathname);
    }

    setBusy(state) { if (this.btn) this.btn.setAttribute('aria-busy', state ? 'true' : 'false'); }
    showError(msg) { if (this.errorEl) { this.errorEl.textContent = msg; this.errorEl.setAttribute('data-shown', 'true'); } }
    clearError() { if (this.errorEl) this.errorEl.removeAttribute('data-shown'); }

    onSubmit(e) {
      e.preventDefault();
      this.clearError();
      var field = this.variant || this.querySelector('[name="id"]');
      var id = field && field.value;
      if (!id) return;
      this.setBusy(true);

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { id: Number(id), quantity: 1 };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        try {
          body.sections = cart.getSectionsToRender().map(function (sec) { return sec.id; });
          body.sections_url = window.location.pathname;
        } catch (err) {}
      }

      fetch(this.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { this.showError((res.data && res.data.description) || 'Sorry, this could not be added.'); this.setBusy(false); return; }
          if (this.onCartPage) { window.location.reload(); return; }
          if (!cart) { window.location.reload(); return; }

          // Notify the cart system so the drawer line items + footer re-render
          // (cart-drawer-items subscribes to this). Matches product-form.js.
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jamun-cart-upsell', cartData: res.data });
            }
          } catch (err) {}

          if (cart.classList) cart.classList.remove('is-empty');
          var inner = cart.querySelector && cart.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');

          if (typeof cart.renderContents === 'function') { cart.renderContents(res.data); }
          if (typeof cart.open === 'function') cart.open();
          this.setBusy(false);
        }.bind(this))
        .catch(function () { window.location.reload(); }.bind(this));
    }
  });
})();